var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import ModalDialog, { ModalFooter, ModalTransition } from '@atlaskit/modal-dialog';
import WorkflowStep from "./workflow-step";
import styled from "styled-components";
import moment from "moment";
import { withAnalytics, withMountTracking, compose } from "@atlassiansox/microscopekit";
var Title = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 20px;\n"], ["\n  padding-bottom: 20px;\n"])));
var Step = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-top: 5px;\n"], ["\n  padding-top: 5px;\n"])));
var WorkflowModalView = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, workflow = _a.workflow, date = _a.date, history = _a.history, service = _a.service;
    if (workflow && workflow.steps) {
        workflow.steps.sort(function (a, b) {
            var keyA = moment(a.startedAt), keyB = moment(b.startedAt);
            if (keyB > keyA) {
                return -1;
            }
            if (keyB < keyA) {
                return 1;
            }
            return 0;
        });
    }
    return (React.createElement("div", null,
        React.createElement(ModalTransition, null, isOpen && (React.createElement(ModalDialog, { heading: "Workflow: " + workflow.id, onClose: onClose },
            React.createElement(Title, null,
                React.createElement("h3", null, "Steps")),
            workflow.steps.map(function (step) { return (React.createElement(Step, { key: step.id + "_" + step.status + "_" + step.updatedAt },
                React.createElement(WorkflowStep, { step: step, date: date, history: history, service: service }))); }),
            React.createElement(ModalFooter, null))))));
};
var WorkflowModal = compose(withAnalytics, withMountTracking('Operations.WorkflowModal'))(WorkflowModalView);
export default WorkflowModal;
var templateObject_1, templateObject_2;
